(($, Drupal) => {
    Drupal.behaviors.categoryDual = {
        attach: function attach() {
            $(".category-dual__wrapper").once("category-dual").each(function() {
                const labelCheckedHash = $(this).find("label[for='" + getHashState("location") + "']");

                const labelsWrapper = $($(this).find(".category-dual__labels"));
                const inputWrapper = $(".category-dual__wrapper");
                labelsWrapper.trigger('to.owl.carousel', labelCheckedHash.parent().index())

                labelsWrapper.find("." + sliderClasses.navContainerClass).addClass('default__nav');


                $(window).on("resize load", function() {
                    if(labelsWrapper.data('owl.carousel')) {
                        if($(window).innerWidth() <= 1024 && $(window).innerWidth() > 768)
                        {
                            labelsWrapper.data('owl.carousel').options.margin = 0;
                            labelsWrapper.data('owl.carousel').options.items = 2;
                            labelsWrapper.data('owl.carousel').options.nav = true;
                            labelsWrapper.trigger('refresh.owl.carousel');
                        }
                        else if($(window).innerWidth() <= 768) {
                            labelsWrapper.data('owl.carousel').options.margin = 0;
                            labelsWrapper.data('owl.carousel').options.items = 1;
                            labelsWrapper.data('owl.carousel').options.nav = true;

                            // case for contacts page for mobile devices
                            labelsWrapper.on('changed.owl.carousel', function (event) {
                              const { index } = event.item;
                              const label = labelsWrapper.find(`.category-dual__label-${index}`);
                              const input = inputWrapper.find(`.category-dual__input-${index}`);

                              if (label && label.length) {
                                label.trigger('click');
                              }

                              if (input && input.length) {
                                input.trigger('click');
                              }
                            });

                            labelsWrapper.trigger('refresh.owl.carousel');
                        }
                        else {
                            labelsWrapper.data('owl.carousel').options.margin = 0;
                            labelsWrapper.data('owl.carousel').options.items = 4;
                            labelsWrapper.data('owl.carousel').options.nav = true;
                            labelsWrapper.trigger('refresh.owl.carousel');
                        }
                    }
                })
            });
        }
    };

})(jQuery, Drupal);
